import { analyticsTrackEvent } from '../../utils/analytics';
import { MATERIALS_ADD_SECTION } from '../../constants/analytics';
import {
  CreateSectionBody,
  CreateSectionContract,
} from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_POST_MATERIAL_SECTIONS } from '../../constants/endpoints';
import request, { getData } from './request';
import toSection from './toSection';

const createSection = async (
  classRoomId: string,
  section: CreateSectionBody,
  localId?: string,
  correlationId?: string,
  educatorOnly?: boolean,
  isRbacEnabled?: boolean
) => {
  const url = CLASSROOM_POST_MATERIAL_SECTIONS(classRoomId, educatorOnly);
  const data = await request<CreateSectionContract>({
    method: 'post',
    headers: {
      'x-correlation-id': correlationId,
    },
    url,
    data: { section, localId },
  }).then(getData);
  try {
    analyticsTrackEvent(MATERIALS_ADD_SECTION, {
      itemId: data.id,
      scheduledFor: data.scheduledFor,
      correlationId,
      spaceId: classRoomId,
      itemType: 'Material',
      isRbacEnabled,
    });
  } catch {
    // Analytics must not turn a successful API request into a failed action.
  }
  return toSection(data);
};

export type CreateSection = typeof createSection;

export default createSection;
